module.exports = __webpack_public_path__ + "static/media/oauth-logo-google.c5ac4cab.svg";